import React from "react";
import { Row, Col, Empty, Pagination } from "antd";
import { useTranslation } from "react-i18next";
import { PatientCard } from "./PatientCard";

export function PatientList({
  patients,
  pagination,
  loading,
  onPageChange,
  onEdit,
  onDelete,
}) {
  const { t } = useTranslation("institution");

  if (!loading && patients.length === 0) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={t("patients.list.empty")}
      />
    );
  }

  return (
    <div className="patient-list">
      <Row gutter={[24, 24]}>
        {patients.map((patient) => (
          <Col xs={24} sm={12} lg={8} xl={6} key={patient._id}>
            <PatientCard
              patient={patient}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </Col>
        ))}
      </Row>

      {pagination.totalPages > 1 && (
        <div style={{ marginTop: 32, textAlign: "center" }}>
          <Pagination
            current={pagination.page}
            total={pagination.totalDocs}
            pageSize={12}
            onChange={onPageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
}
